import React from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import "./PaymentInfo.scss";
import { useLanguage } from "../../LanguageProvider";

const PaymentInfo = ({ title, text, isSuccess, isModalOpen, closeModal, registrationData }) => {
  const { languageData } = useLanguage();
  const navigate = useNavigate();

  const handlePayment = (option) => {
    if (option === "pay_now") {
      // Store registration data in session storage for payment page
      sessionStorage.setItem('registrationData', JSON.stringify(registrationData));
      
      // Navigate to payment page
      navigate('/payment', { state: { registrationData } });
    } else {
      // User chose to pay at the event
      closeModal();
    }
  };

  return (
    <Modal
      appElement={document.getElementById("root")}
      className={`modal ${isSuccess ? 'modal-success' : 'modal-failure'}`}
      isOpen={isModalOpen}
    >
      <div className="modal__container">
        <h2 className="modal__title">
          {title}
        </h2>
        <p className="modal__subheader">
          {text}
        </p>

        <br/>
        <p className="modal__payment-question">{languageData.registration.paymentQuestion}</p>
        <p className="modal__payment-hint">{languageData.registration.paymentHint}</p>

        <div className="modal__payment-options">
          <button onClick={() => handlePayment("pay_now")} className="modal__close-btn">{languageData.registration.payNow}</button>
          <button onClick={() => handlePayment("pay_later")} className="modal__close-btn">{languageData.registration.payAtEvent}</button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentInfo;